import React from 'react';
import { number } from 'prop-types';
import { s_star, s_star_half } from '@fiverr-private/fit/icons';
import { Icon } from '@fiverr-private/fit';
import './style.scss';

/**
 * Returns proper stars representation for a given ratings count.
 * @param {Number} ratings The ratings count.
 * @return {Function[]}
 */
const getRatingStars = (ratings) => {
    const ratingIcons = [];

    while (ratings > 0) {
        ratingIcons.push(ratings > 0.5 ? s_star : s_star_half);

        ratings--;
    }

    return ratingIcons;
};

const Ratings = ({ ratings = 0 }) => (
    <span className="ratings flex">
        {getRatingStars(ratings).map((ratingIcon, index) => (
            <Icon key={index} size={14} className="star">{ratingIcon}</Icon>
        ))}
    </span>
);

Ratings.propTypes = {
    ratings: number.isRequired
};

export default Ratings;
